import { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@blaze-react/button';
import { FaChevronLeft, FaTimes } from 'react-icons/fa';
import MenuList from './MenuList';
import Logo from '../../Logo';

const MobileMenu = ({ onClose, headerMenu }) => {
  const [itemData, setItemData] = useState({
    itemName: '',
    itemHref: ''
  });

  const currentItemName = itemData.itemName;
  const headerMenuProps = currentItemName
    ? headerMenu.find(({ name }) => name === currentItemName).items
    : headerMenu;

  const handleClick = ({ itemName = '', itemHref = '', itemAction = '' }) => {
    if (itemAction === 'close') return onClose(false);
    setItemData({ itemName, itemHref });
  };

  return (
    <div className="responsive-nav" id="responsive-nav" data-testid="header-mobile-menu">
      <div className="menu menu--responsive-nav">
        <div className="menu__header menu__header--responsive-nav">
          {currentItemName ? (
            <Button
              type="button"
              className="icon-button icon-button--menu-back"
              buttonid="menu-button-back"
              data-testid="mobileMenu-button-back"
              onClick={() => handleClick({})}>
              <i>
                <FaChevronLeft />
              </i>
            </Button>
          ) : (
            <Logo type="menu" modifier="header__logo-link" />
          )}
          {currentItemName && (
            <div className="menu--responsive-nav__current-submenu" data-testid="current-item-div">
              {currentItemName}
            </div>
          )}
          <Button
            type="button"
            className="icon-button icon-button--menu-close"
            buttonid="menu-button-close"
            data-testid="mobileMenu-button-close"
            onClick={() => onClose(false)}>
            <i>
              <FaTimes />
            </i>
          </Button>
        </div>
        <MenuList headerMenu={headerMenuProps} handleClick={handleClick} {...itemData} />
      </div>
    </div>
  );
};

MobileMenu.propTypes = {
  onClose: PropTypes.func.isRequired,
  headerMenu: PropTypes.array
};

MobileMenu.defaultProps = {
  headerMenu: []
};

export default MobileMenu;
